import { render, staticRenderFns } from "./Carbon.vue?vue&type=template&id=4f6cbc6e&"
import script from "./Carbon.vue?vue&type=script&lang=js&"
export * from "./Carbon.vue?vue&type=script&lang=js&"
import style0 from "./Carbon.vue?vue&type=style&index=0&id=4f6cbc6e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports